import { render, staticRenderFns } from "./InspectOrderPageEdit.vue?vue&type=template&id=718cc692&scoped=true"
import script from "./InspectOrderPageEdit.vue?vue&type=script&lang=js"
export * from "./InspectOrderPageEdit.vue?vue&type=script&lang=js"
import style0 from "./InspectOrderPageEdit.vue?vue&type=style&index=0&id=718cc692&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718cc692",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('718cc692')) {
      api.createRecord('718cc692', component.options)
    } else {
      api.reload('718cc692', component.options)
    }
    module.hot.accept("./InspectOrderPageEdit.vue?vue&type=template&id=718cc692&scoped=true", function () {
      api.rerender('718cc692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screening/inspectOrder/inspectOrderPage/InspectOrderPageEdit.vue"
export default component.exports